import PropTypes from 'prop-types';

export default PropTypes.shape({
  id: PropTypes.string,
  uuid: PropTypes.string,
  type: PropTypes.string,
  disabilityType: PropTypes.string,
  isCompany: PropTypes.bool,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  unformattedPhoneNumber: PropTypes.objectOf(
    PropTypes.shape({
      countryCode: PropTypes.string,
      number: PropTypes.string
    })
  ),
  birthDate: PropTypes.string,
  travelDocumentsRequired: PropTypes.arrayOf(
    PropTypes.shape({
      travelDocumentType: PropTypes.string,
      required: PropTypes.bool
    })
  )
});
